module.exports = __webpack_public_path__ + "img/other-2.95af3644.png";